import React from "react";
import { ContentSection } from "sprint-common-web";

import { RecordType } from "../../../../../../common/types/RecordType";
import { useCloudAssetDetails } from "../../../common/hooks/useCloudAssetDetails";
import { CloudAudioLanguagesSection } from "./audio/CloudAudioLanguagesSection";
import { CloudSubtitleLanguagesSection } from "./subtitle/CloudSubtitleLanguagesSection";
import { CloudVideoAssetLanguagesSection } from "./video/CloudVideoLanguagesSection";

export const CloudLanguagesSection = (): JSX.Element => {
    const { isLoading, data: assetDetails } = useCloudAssetDetails();

    switch (assetDetails?.type) {
        case RecordType.Audio:
            return <CloudAudioLanguagesSection isLoading={isLoading} language={assetDetails.soundtrack} />;
        case RecordType.Subtitle:
            return <CloudSubtitleLanguagesSection isLoading={isLoading} language={assetDetails.subtitle} />;
        case RecordType.Video:
            return <CloudVideoAssetLanguagesSection isLoading={isLoading} language={assetDetails.subtitle} />;
        default:
            return <ContentSection header="Languages" isLoading={true} />;
    }
};
